import store from '@/store'

export function getMvzItems () {
  return store.getters.mvzspp.mvzItems
}

export function getSppItems () {
  return store.getters.mvzspp.sppItems
}

export function getAgentAgreements () {
  return store.getters.mvzspp.agentAgreements
}

export function getOrganizations () {
  return store.getters.mvzspp.organizations
}

export function findMvzSpp (code) {
  let item
  const codeStr = (code && String(code).toString()) || null

  item = getMvzItems().find(el => el.code === codeStr)
  if (item !== undefined) {
    return {type: 'mvz', item}
  }
  item = getSppItems().find(el => el.code === codeStr)
  if (item !== undefined) {
    return {type: 'spp', item}
  }
  item = getAgentAgreements().find(el => el.code === codeStr)
  if (item !== undefined) {
    return {type: 'agreement', item}
  }
  return {}
}

/**
 * Find agreement by organization name
 *
 * @param organization
 * @returns {{item: *, type: string}|{}}
 */
export function findAgentAgreement (organizationId) {
  return getAgentAgreements().find(el => el.organizationId === organizationId)
}



// WEBPACK FOOTER //
// ./src/utils/mvzsppUtil.js